import { useEffect, useState } from "react";
import {
    ArrayPath,
    FieldError,
    FieldValues,
    Path,
    useFormContext
} from "react-hook-form";

const useFormErrors = <T extends FieldValues>(name: Path<T> | ArrayPath<T>) => {
    const { subscribe } = useFormContext<T>();
    const [error, setError] = useState<FieldError | undefined>(undefined);

    // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
    useEffect(() => {
        const callback = subscribe({
            formState: { errors: true },
            callback: ({ errors }) => {
                if (!errors) return;
                const error = errors[name]?.root || errors[name];
                if (error) {
                    if (Array.isArray(error)) {
                        const arrayError = error.at(0);
                        setError(arrayError as FieldError);
                    } else {
                        setError(error as FieldError);
                    }
                } else {
                    setError(undefined);
                }
            }
        });

        return () => callback();
    }, [subscribe]);

    return { error };
};

export { useFormErrors };
